import { Injectable, inject } from '@angular/core';
import { FileApi } from 'src/api/file.api';
import { FileBaseService } from './file-base.service';

@Injectable()
export class BugReportService extends FileBaseService {
  protected fileApi: FileApi;

  constructor() {
    const fileApi = inject(FileApi);

    super('BugReport', fileApi);
  }
}
